<template>
  <div style="background-color: gray">
    <div  class="rightBut">
      <div @click="onMoreFilter" v-if="ifposition">更多筛选</div>
    </div>
    <div style="background-color: white; padding-left: 36px; padding-bottom: 6px;"></div>

    <div style="background-color: white;overflow: hidden;">
        <div style="width:90%;margin:0px auto;" v-if="technicianArr.length>0">
            <div style="height:20px;line-height:20px;text-align:center;color:#1879FF;display: flex;">
                <div style="width:40%"> </div>
                <div style="width:60%;text-align:center;">{{Tcname}}</div>

            </div>
            <div style="width:100%;height:1px;background-color: #E7E7E7;margin:4px 0px;"></div>
            <div v-for="procedure in $store.state.data.DispatchableProcedure" :key="procedure.id" :label="procedure.name">
                <div style="display:flex;" v-if="technicianArr[0].procedureMap[procedure.id]">
                    <div style="width: 40%;text-align: center;background-color: #C9C9C9;color:#1879FF;">
                        {{procedure.name}}
                    </div>
                    <div style="width: 60%;text-align: center">
                        {{!technicianArr?0:technicianArr[0].procedureMap[procedure.id]}}
                        <span v-if="technicianArr[0].technicianType==='PAINT'">(面)</span>
                        <span v-else>(时)</span>
                    </div>
                </div>
                <div style="width:100%;height:1px;background-color: #E7E7E7;margin:4px 0px;" v-if="technicianArr[0].procedureMap[procedure.id]"></div>
            </div>
        </div>
    </div>

    <van-popup v-model="showFilter" position="bottom" :style="{height}" round
               safe-area-inset-bottom>
      <wx-work-report-filter :show.sync="showFilter" :TsList="technicianNameList" @onTechnician="onTechnicianbit">
      </wx-work-report-filter>
    </van-popup>
  </div>
</template>

<script>
import { Sticky, Search, Popup } from 'vant'
import WxWorkReportFilter from '@/views/wx/WxWorkReportFilter'
import { technicianWorkHoursByWeChat, technicianList } from '@/utils/request'
import { checkHasPosition } from '@/utils/auth-directive'

export default {
    name: 'WxWorkReport',
    components: {
        WxWorkReportFilter,
        [Search.name]: Search,
        [Sticky.name]: Sticky,
        [Popup.name]: Popup
    },
    data () {
        return {
            searchText: '',
            showFilter: false,
            technicianArr: [],
            Procedure: null,
            technicianNameList: [],
            Tcname: null
        }
    },
    created () {
        this.$store.dispatch('data/kvList', 'DispatchableProcedure')
        this.Procedure = this.$store.state.data.DispatchableProcedure

        this.TcQuery()
    },
    methods: {
        onMoreFilter () {
            this.showFilter = true
        },
        onTechnicianbit (begTime, endTime, picker, show) {
            this.showFilter = show
            if (picker.id !== null) {
                this.Tcname = picker.text
                begTime = new Date(begTime).getTime() / 1000
                endTime = new Date(endTime).getTime() / 1000
                technicianWorkHoursByWeChat(picker.id, begTime, endTime).then(response => {
                    this.technicianArr = response.data
                })
            }
        },
        FiltersTechnician (userlist) {
            if (userlist.id !== undefined) {
                this.technicianNameList.push({ id: userlist.id, text: userlist.name })
            } else {
                technicianList().then(response => {
                    response.data.forEach(item => {
                        if (item.technicianType === 'SHEET_METAL' || item.technicianType === 'PAINT') {
                            this.technicianNameList.push({ id: item.id, text: item.name })
                        }
                    })
                })
            }
        },
        TcQuery () {
            var userlist = []
            if (this.$isTechnician()) {
                userlist.id = this.$store.state.user.userId
                userlist.name = this.$store.state.user.name
                this.Tcname = userlist.name
                this.TcWorkHours(userlist.id)
            }
            this.FiltersTechnician(userlist)
        },
        TcWorkHours (id) {
            technicianWorkHoursByWeChat(id).then(response => {
                this.technicianArr = response.data
            })
        }
    },
    computed: {
        height () {
            return '70%'
        },
        ifposition () {
            if (!checkHasPosition('TECHNICIAN_PO')) {
                if (checkHasPosition('ROOT_MANAGER_PO') || checkHasPosition('GROUP_MANAGER_PO') || checkHasPosition('AFTER_SALES_MANAGER_PO') || checkHasPosition('WORKSHOP_SUPERVISOR_PO')) {
                 return true
                } else {
                    return false
                }
            } else {
                return true
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.technician{
    background-color: white;
    margin: 0px 4px 8px;
    overflow: hidden;
}
.technician-list{
    display: flex;
    justify-content: space-between;
}
.rightBut{
    position: absolute;
    top: 12px;
    right: 10px;
    z-index: 999;
    font-size: 14px;
    color: #1989fa;
    height: 22px;
    line-height: 22px;
}
</style>
